import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentBranding } from '../models/document-branding.model';

@Component({
  selector: 'app-quotation-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './quotation-footer.component.html',
  styleUrls: ['./quotation-footer.component.scss']
})
export class QuotationFooterComponent {
  @Input() branding: DocumentBranding | null = null;
  @Input() vendorDetails: any = null;
}
